import React from "react";
import I18n from "i18n-js";

import RadioGroup from "./RadioGroup";

const TimeForm = ({ availableHourStyles, hourStyle, onHourStyleSelected }) => {

  const styles = availableHourStyles.map(style => ({
    label: I18n.t(`settings.pages.date_time.time_format.options.${style}`),
    value: style
  }));

  const handleOnHourStyleSelected = (item) => {
    const style = item.value;
    onHourStyleSelected && onHourStyleSelected(style);
  }

  return (
    <div className="time-form">
      <RadioGroup
        label={I18n.t("settings.pages.date_time.time_format.title")}
        items={styles}
        initialValue={hourStyle}
        onItemSelected={handleOnHourStyleSelected}
      />
    </div>
  );
}

export default TimeForm;
